import React, { useState } from "react";
import "./Order_card.css";
import { useNavigate } from "react-router-dom";
import { Order_Status } from "../../../utils/common";
import { Rating } from "react-simple-star-rating";
import Add_Reviews from "../../common_components/add_Reviews/Add_Reviews";
import ReactStars from "react-rating-stars-component";
function Order_card({
  order,
  img,
  status,
  statusClass,
  title,
  description,
  mrp,
  date,
  sellingPrice,
  discount,
  onAddReviewClick,
  orderGet
}) {
  const [rating, setRating] = useState(0);
  const navigate = useNavigate();

  const [showReviewModal, setShowReviewModal] = useState(false);

  const handleOpenModal = () => {
    setShowReviewModal(true);
  };

  const handleCloseModal = () => {
    setShowReviewModal(false);
  };

  const ratingChanged = (newRating) => {
    setRating(newRating);
  
  };
  return (
    <>
      <section className="Order_card" style={{ cursor: "pointer" }}>
        <div
          className="img_holder"
          onClick={() => navigate(`/luxury/order-details/${order?.id}`)}
        >
          <div>
            <img src={img} alt="product" className="product_img" />
          </div>
        </div>

        <div className="product_info_holder">
          <div
            className="order_status_holder"
            onClick={() => navigate(`/luxury/order-details/${order?.id}`)}
          >
            <h3 className={statusClass}>({status})</h3>
          </div>

          <h4>{title}</h4>
          <h6>{description}</h6>

          <div className="row">
            <div className="col-md-6">
              <div className="price_text">
                <h5 className="Mrp_price">MRP: ₹ {mrp}</h5>
                <h6 className="Mrp_price mb-3">{date}</h6>
              </div>
            </div>

            <div className="col-md-6">
              <div className="price_text">
                <h5 className="selling_price">
                  Selling Price: ₹ {sellingPrice}
                </h5>
                <p className="descount_price">{discount}</p>
              </div>
            </div>
          </div>
          {(Number(order?.order_status_id) === Number(Order_Status.Deliverd))&&order?.product_review ==null && (
            <>
              <div className="star_rate_holder">
                <p>
                  Rate this Product :-{" "}
                  <ReactStars
                    count={5}
                    value={rating}
                    onChange={ratingChanged}
                    size={24}
                    activeColor="#ffd700"
                  />
                  {/* <Rating
                    value={rating}
                    onChange={(newRating) => setRating(newRating)}
                  /> */}
                </p>
              </div>

              <div className="rate_now_text_holder">
                <p onClick={handleOpenModal} className="add_review_text">
                  Add Reviews
                </p>
              </div>
            </>
          )}
        </div>
        <Add_Reviews
        orderGet={orderGet}
          show={showReviewModal}
          onHide={handleCloseModal}
          rating={rating}
          product_id={order?.product_id}
          order_id={order?.id}
        />
      </section>
    </>
  );
}

export default Order_card;
